import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {Offer} from '@/models/simulation/Simulation';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOffers',
  setup(__props) {

const store = useSimulationStore();

const isAnyOfferInvisibleByAppliedFilters = computed<boolean>(() => {
  const offers: Offer[] = (store.isShownAvailableProducts
    ? store.simulation?.offers : store.simulation?.refusedOffers) ?? [];
  const isSomeFilterSelected: boolean = store.selectedFiltersCount > 0;
  return isSomeFilterSelected && offers.length > 0;
});

const isAnyOfferAvailableOrRefused = computed<boolean>(() =>
  Boolean(store.simulation?.refusedOffers?.length || store.simulation?.offers?.length));

return { __sfc: true,store, isAnyOfferInvisibleByAppliedFilters, isAnyOfferAvailableOrRefused, I18NGetter }
}

})